<template>
  <component :is="image.url ? 'a' : 'div'" :href="image.url" target="_blank" class="d-block">
    <lazy-background
      class="w-100"
      :src="image.src"
      position="center"
      size="cover"
      repeat="no-repeat"
      :delay="3000"
      :aspect-ratio="image.aspect === 'square' ? 1 : (10 / 15)"
    />
  </component>
</template>

<script>
export default {
  name: "Pic",
  props: {
    image: {
      type: Object,
      required: true
    }
  }
};
</script>
